// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iframe {
  background-color: white;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 3px solid #f4f4f4;
}

.active {
  color: rgb(235, 50, 145);
}

a:hover {
  opacity: 0.5;
}

.center {
  transition: 0.5s;
  margin-left: auto;
  margin-right: auto;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImlmcmFtZS5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJLHVCQUFBO0VBQ0Esa0NBQUE7RUFDQSx1Q0FBQTtFQUNBLDBDQUFBO0VBQ0EseUJBQUE7QUFDSjs7QUFFQTtFQUNJLHdCQUFBO0FBQ0o7O0FBQ0E7RUFDSSxZQUFBO0FBRUo7O0FBQUE7RUFDSSxnQkFBQTtFQUNBLGlCQUFBO0VBQ0Esa0JBQUE7QUFHSiIsImZpbGUiOiJpZnJhbWUuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuaWZyYW1le1xuICAgIGJhY2tncm91bmQtY29sb3I6IHdoaXRlO1xuICAgIGJvcmRlci1yYWRpdXM6IDEwcHggMTBweCAxMHB4IDEwcHg7XG4gICAgLW1vei1ib3JkZXItcmFkaXVzOiAxMHB4IDEwcHggMTBweCAxMHB4O1xuICAgIC13ZWJraXQtYm9yZGVyLXJhZGl1czogMTBweCAxMHB4IDEwcHggMTBweDtcbiAgICBib3JkZXI6IDNweCBzb2xpZCAjZjRmNGY0O1xufVxuXG4uYWN0aXZlIHtcbiAgICBjb2xvcjogcmdiKDIzNSwgNTAsIDE0NSk7XG59XG5hOmhvdmVye1xuICAgIG9wYWNpdHk6IC41O1xufVxuLmNlbnRlcntcbiAgICB0cmFuc2l0aW9uOiAwLjVzO1xuICAgIG1hcmdpbi1sZWZ0OiBhdXRvO1xuICAgIG1hcmdpbi1yaWdodDogYXV0bztcbn0iXX0= */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/legacy/shared-libs/iframe/iframe.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,kCAAA;EACA,uCAAA;EACA,0CAAA;EACA,yBAAA;AACJ;;AAEA;EACI,wBAAA;AACJ;;AACA;EACI,YAAA;AAEJ;;AAAA;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;AAGJ;AACA,w5BAAw5B","sourcesContent":[".iframe{\n    background-color: white;\n    border-radius: 10px 10px 10px 10px;\n    -moz-border-radius: 10px 10px 10px 10px;\n    -webkit-border-radius: 10px 10px 10px 10px;\n    border: 3px solid #f4f4f4;\n}\n\n.active {\n    color: rgb(235, 50, 145);\n}\na:hover{\n    opacity: .5;\n}\n.center{\n    transition: 0.5s;\n    margin-left: auto;\n    margin-right: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
